import {
  TNewbuildingBookedOfferLayoutsActions,
  ENewbuildingBookedOfferLayoutsActionTypes,
} from '../../actions/newbuildingBookedOfferLayouts';
import { INewbuildingLayoutOffer } from '../../types/newbuildingBookedOfferLayouts/newbuildingLayoutOffer';

const DEFAULT_STATE: INewbuildingLayoutOffer[] = [];

export const newbuildingBookedOfferLayoutsReducer = (
  state: INewbuildingLayoutOffer[] = DEFAULT_STATE,
  action: TNewbuildingBookedOfferLayoutsActions,
): INewbuildingLayoutOffer[] => {
  switch (action.type) {
    case ENewbuildingBookedOfferLayoutsActionTypes.SetBookedOfferLayouts:
      return action.payload;

    default:
      return state;
  }
};
